module.exports = __webpack_public_path__ + "static/media/N40.b224d373.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/N40.svg
// module id = 196
// module chunks = 0